import React from 'react';
import { FaHandshake, FaHeadset, FaCar, FaMapMarkerAlt, FaShieldAlt, FaRupeeSign } from 'react-icons/fa';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const features = [
    {
      id: 'reliable',
      icon: FaHandshake,
      title: 'Super & Reliable Services',
      description: 'Trusted and dependable service delivery'
    },
    {
      id: 'support',
      icon: FaHeadset,
      title: '24 X 7 Customer Support Provide',
      description: 'Round-the-clock customer support'
    },
    {
      id: 'models',
      icon: FaCar,
      title: 'Large Range Of Car Models',
      description: 'Wide selection of vehicle models'
    },
    {
      id: 'gps',
      icon: FaMapMarkerAlt,
      title: 'GPS Tracking And Help',
      description: 'Real-time tracking and assistance'
    },
    {
      id: 'security',
      icon: FaShieldAlt,
      title: 'Powerful Security Service',
      description: 'Strong and robust security service'
    },
    {
      id: 'fare',
      icon: FaRupeeSign,
      title: 'Lowest Fare In Market',
      description: 'Competitive pricing guaranteed'
    }
  ];

  return (
    <div id="why-choose-section" className="why-choose-us">
      <div className="why-choose-container">
        <h2 className="why-choose-title">Why Choose Us?</h2>
        
        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card">
              <div className="feature-icon">
                <feature.icon />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;

